
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"enable-background":"new 0 0 220.682 220.682"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","width":"220.682px","height":"220.682px","viewBox":"0 0 220.682 220.682","style":"enable-background:new 0 0 220.682 220.682;","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('polygon',{attrs:{"points":"92.695,38.924 164.113,110.341 92.695,181.758 120.979,210.043 220.682,110.341 120.979,10.639  "}}),_c('polygon',{attrs:{"points":"28.284,210.043 127.986,110.341 28.284,10.639 0,38.924 71.417,110.341 0,181.758  "}})])
          )
        }
      }
    